import {
    URLAPI,
    MAINTENANCE_SURVEY_OPTION_CREATE_PATH,
    MAINTENANCE_SURVEY_OPTION_UPDATE_PATH,
} from "../config/index";
import {LOGOUT} from './users';
import axios from "axios";

const init = {
    _create_maintenance_survey_option: {
        data: {},
        status: 0,
        message: {},
    },
    _update_maintenance_survey_option: {
        data: {},
        status: 0,
        message: {},
    },
};

export const CREATE_MAINTENANCE_SURVEY_OPTION = "CREATE_MAINTENANCE_SURVEY_OPTION";
export const UPDATE_MAINTENANCE_SURVEY_OPTION = "UPDATE_MAINTENANCE_SURVEY_OPTION";

export const maintenance_survey_option_module = (state = init, action) => {
    switch (action.type) {
        case CREATE_MAINTENANCE_SURVEY_OPTION:
            return {
                ...state,
                _create_maintenance_survey_option: action.payload,
            };
        case UPDATE_MAINTENANCE_SURVEY_OPTION:
            return {
                ...state,
                _update_maintenance_survey_option: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
};

export const createMaintenanceSurveyOption = (token, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.post(
            `${URLAPI}${MAINTENANCE_SURVEY_OPTION_CREATE_PATH}`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: CREATE_MAINTENANCE_SURVEY_OPTION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: CREATE_MAINTENANCE_SURVEY_OPTION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_MAINTENANCE_SURVEY_OPTION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const updateMaintenanceSurveyOption = (token, id, data) => async (dispatch) => {
    try {
        let form = new FormData();

        for (var key in data) {
            form.append(key, data[key]);
        }
        const response = await axios.patch(
            `${URLAPI}${MAINTENANCE_SURVEY_OPTION_UPDATE_PATH}${id}/`,
            form,
            {
                headers: {
                    Authorization: `Token ${token}`,
                },
            }
        );
        dispatch({
            type: UPDATE_MAINTENANCE_SURVEY_OPTION,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response) {
            dispatch({
                type: UPDATE_MAINTENANCE_SURVEY_OPTION,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_MAINTENANCE_SURVEY_OPTION,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
};

export const clear_maintenance_survey_option = (type) => async (dispatch) => {
    dispatch({
        type: type,
        payload: {
            data: [],
            status: 0,
            message: {},
        },
    });
};
